module.exports = __webpack_public_path__ + "7301477fd7f26197005e004af4a222db.fbx";